import script from "./insurance-form-main-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-form-main-info.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-form-main-info.vue?vue&type=style&index=0&id=19ac0faa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ac0faa"]])

export default __exports__